"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImportUnits = exports.useUpdateUnits = exports.useCreateUnits = exports.useFetchUnits = void 0;
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const unitsAction_1 = require("./unitsAction");
const useFetchUnits = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const unitsFetchLoading = (0, react_redux_1.useSelector)((state) => state['units/fetch'].loading);
    const unitsFetchError = (0, react_redux_1.useSelector)((state) => state['units/fetch'].error);
    const unitsFetchData = (0, react_redux_1.useSelector)((state) => state['units/fetch'].data);
    const unitsFetch = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!isUserLogged) {
            history('/auth/sign-in');
        }
        yield dispatch((0, unitsAction_1.fetch)(payload));
    });
    return { unitsFetch, unitsFetchLoading, unitsFetchError, unitsFetchData };
};
exports.useFetchUnits = useFetchUnits;
const useCreateUnits = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const unitsCreateLoading = (0, react_redux_1.useSelector)((state) => state['units/create'].loading);
    const unitsCreateError = (0, react_redux_1.useSelector)((state) => state['units/create'].error);
    const unitsCreateData = (0, react_redux_1.useSelector)((state) => state['units/create'].data);
    const unitsCreate = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!isUserLogged) {
                history('/auth/sign-in');
            }
            const res = yield dispatch((0, unitsAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, 'Success');
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error while creating units');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return { unitsCreate, unitsCreateLoading, unitsCreateError, unitsCreateData };
};
exports.useCreateUnits = useCreateUnits;
const useUpdateUnits = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const unitsUpdateLoading = (0, react_redux_1.useSelector)((state) => state['units/update'].loading);
    const unitsUpdateError = (0, react_redux_1.useSelector)((state) => state['units/update'].error);
    const unitsUpdateData = (0, react_redux_1.useSelector)((state) => state['units/update'].data);
    const unitsUpdate = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!isUserLogged) {
                history('/auth/sign-in');
            }
            const res = yield dispatch((0, unitsAction_1.update)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, 'Success');
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error while updating units');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return { unitsUpdate, unitsUpdateLoading, unitsUpdateError, unitsUpdateData };
};
exports.useUpdateUnits = useUpdateUnits;
const useImportUnits = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const unitsImportLoading = (0, react_redux_1.useSelector)((state) => state['units/import'].loading);
    const unitsImportError = (0, react_redux_1.useSelector)((state) => state['units/import'].error);
    const unitsImportData = (0, react_redux_1.useSelector)((state) => state['units/import'].data);
    const unitsImport = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let isUserLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!isUserLogged) {
                history('/auth/sign-in');
            }
            const res = yield dispatch((0, unitsAction_1.importUnits)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, 'Success');
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error while importing units');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return { unitsImport, unitsImportLoading, unitsImportError, unitsImportData };
};
exports.useImportUnits = useImportUnits;
